import { Schema } from "effect";
import { WorkerstationState } from "../models.ts";
import { StationId } from "../station-id.ts";
import { CommitId, TreeId } from "../development-identifiers.ts";

export const STATION_HTTP_PREFIX = "/api/workerstation";
export const StationRevision = /* @__PURE__ */ (() => Schema.Int.check(Schema.isBetween({ minimum: 0, maximum: Number.MAX_SAFE_INTEGER })))();
export const StationHttpState = /* @__PURE__ */ (() => Schema.StructWithRest(Schema.Struct({
  ...WorkerstationState.fields,
  commitId: Schema.optionalKey(CommitId), treeId: Schema.optionalKey(TreeId), refRevision: Schema.optionalKey(StationRevision)
}), [Schema.Record(Schema.String, Schema.Json)]))();
export type StationHttpState = typeof StationHttpState.Type;
export const StationUpdatePayload = /* @__PURE__ */ (() => Schema.Struct({
  workspaces: Schema.Array(Schema.String), active: Schema.optionalKey(Schema.String), expectedUpdatedAt: Schema.optionalKey(StationRevision)
}))();
export const StationUpdate = /* @__PURE__ */ (() => Schema.Struct({
  workspaces: Schema.Array(StationId).check(Schema.isMinLength(1), Schema.isMaxLength(32)), active: StationId,
  expectedUpdatedAt: Schema.optionalKey(StationRevision)
}))();
export type StationUpdate = typeof StationUpdate.Type;
export const StationUpdated = /* @__PURE__ */ (() => Schema.Struct({ ok: Schema.Literal(true), updatedAt: Schema.optionalKey(StationRevision) }))();
export const StationCompareResult = /* @__PURE__ */ (() => Schema.Union([
  Schema.Struct({ ok: Schema.Literal(true), updatedAt: StationRevision }),
  Schema.Struct({ ok: Schema.Literal(false), currentUpdatedAt: Schema.NullOr(StationRevision) })
]))();
export type StationCompareResult = typeof StationCompareResult.Type;
